import { IS_TESTING } from "@/__main__/constants.mjs";
import globals from "@/util/global-whitelist.mjs";

type UTMParameters = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
};

/**
 * Important caveat: this function only works for in-app (relative) links.
 * For external links, just hardcode the query parameters.
 */
export default function (href: string, utm: UTMParameters) {
  if (IS_TESTING) return href;
  const url = new URL(href, globals.location.origin);

  Object.entries(utm).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });

  return decodeURI(`${url.pathname}${url.search}`);
}
